var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 100,
    viewBox: "0 0 103 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_9894)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8102 12.4022C56.3724 11.6664 62.183 14.4008 66.2419 20.6053C70.2532 28.7965 68.8919 35.9904 62.1579 42.1873C56.6041 46.1645 50.6275 46.8807 44.2282 44.3357C36.3521 40.1871 33.1977 33.7744 34.7653 25.0975C36.8181 18.0383 41.4997 13.8065 48.8102 12.4022Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3262 24.9024C25.6932 24.2629 30.3748 26.6717 33.3711 32.1289C35.6792 38.149 34.3843 43.2598 29.4863 47.461C25.6749 50.0221 21.5576 50.608 17.1348 49.2188C11.813 47.024 9.02395 43.0854 8.76758 37.4024C9.25335 30.7436 12.7729 26.577 19.3262 24.9024Z",
    fill: "#D6292D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8924 24.9026C86.6299 24.2811 91.5771 27.6014 93.7342 34.8635C94.6572 42.2223 91.5693 47.1377 84.4705 49.6096C77.7115 50.8366 72.6979 48.5252 69.4295 42.676C67.121 36.6581 68.4159 31.5473 73.3143 27.344C75.0198 26.1491 76.8793 25.3352 78.8924 24.9026Z",
    fill: "#D6292D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9126 99.9028C58.9048 99.9028 43.8969 99.9028 28.8891 99.9028C27.4317 99.4177 26.4688 98.4411 26.0005 96.9731C25.8044 82.9686 25.8708 68.9714 26.1997 54.9809C28.4827 48.5202 33.1311 45.3952 40.145 45.6059C41.1909 45.6118 42.187 45.7419 43.1333 45.9966C45.8307 54.028 48.5865 62.0358 51.4009 70.02C54.2286 61.9634 57.0176 53.8905 59.768 45.8012C64.2407 45.0014 68.358 45.8151 72.1196 48.2427C74.5762 50.2927 76.1366 52.8643 76.8012 55.9575C76.9341 69.6944 76.9341 83.4315 76.8012 97.1684C76.2486 98.5245 75.2858 99.436 73.9126 99.9028Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.400391 88.7695C0.400391 79.3295 0.400391 69.8892 0.400391 60.4492C1.34606 57.341 3.40465 55.2902 6.57617 54.2968C12.4103 53.9777 18.254 53.9125 24.1074 54.1015C22.8254 56.2443 22.0618 58.5554 21.8164 61.0351C21.7168 71.2562 21.6835 81.4777 21.7168 91.6992C15.7399 91.7318 9.76329 91.6992 3.78711 91.6015C2.19371 91.1779 1.0648 90.2338 0.400391 88.7695Z",
    fill: "#D6292D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.4 60.6445C102.4 70.0195 102.4 79.3945 102.4 88.7695C101.736 90.2338 100.607 91.1779 99.0137 91.6015C93.0375 91.6992 87.0609 91.7318 81.084 91.6992C81.1173 81.4777 81.084 71.2562 80.9844 61.0351C80.7389 58.5554 79.9753 56.2443 78.6934 54.1015C84.5468 53.9125 90.3905 53.9777 96.2246 54.2968C99.4842 55.3111 101.543 57.4269 102.4 60.6445Z",
    fill: "#D6292D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_9894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.38d134310bf7cf0da82faffc4da1b1ec.svg";
export { ForwardRef as ReactComponent };